import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * LibrariesPanelWrapper component styles
 * @returns {Function}
 */

const headerHeight = '4.7rem';

export const useStyles = makeStyles((theme) =>
  createStyles({
    librariesPanelWrapper: {
      display: 'flex',
      flexDirection: 'column',
      // position: 'absolute',
      top: 0,
      zIndex: 1,
      width: '43rem',
      backgroundColor: variables.colorV2.body.background.default,

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        // width: '25rem!important',
        // width: 'calc((100% - 65rem)/2)!important',
        width: '100%!important',
      },
    },

    moduleLibrariesPanelWrapper: {
      // backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
    },

    header: {
      height: headerHeight,
      padding: '1.4rem 1.6rem',
      borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
    },

    returnBackBtn: {
      padding: 0,
      marginRight: theme.spacing(1.25),
    },

    content: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '1 1 auto',
      overflowY: 'auto',
      padding: '2rem 1.6rem',
      // height: '100%', // `calc(100% - ${headerHeight})`,
    },

    notImageLibrary: {
      borderRadius: '0 0 2rem 2rem',
    },
  }),
);
